import { SidebarSelectedWord, SidebarSelectedWordsList, UnitCard } from "p6m-p6u";

/**
 * builds a fresh drawer entry for a newly selected card
 */
export const buildSelectedWord = (card: UnitCard): SidebarSelectedWord => {
    return { wordContent: card, isInMoreThanOneExercise: false, exerciseIds: [] };
};

/**
 * words that haven't been used yet (meaning: without exerciseIds assigned / newly selected)
 */
export const filterVocabularyForNotSelectedWords = (
    vocabulary: SidebarSelectedWordsList
): Array<SidebarSelectedWord> => {
    return Object.values(vocabulary).filter((c: SidebarSelectedWord) => !c.exerciseIds || c.exerciseIds?.length === 0);
};

/**
 * returns drawer content with the given cards added (skips already-selected ones)
 */
export const addCardsToDrawerContent = (
    drawerContent: SidebarSelectedWordsList,
    cards: Array<UnitCard>
): SidebarSelectedWordsList => {
    const words = { ...drawerContent };
    cards.forEach((card) => {
        if (card.id && !words[card.id]?.wordContent?.id) {
            words[card.id] = buildSelectedWord(card);
        }
    });
    return words;
};
